export const heroData = {
  tagline: '全网吃瓜第一站',
  h1: '51吃瓜官网 — 全网最新吃瓜入口大全',
  slogan: '热点追踪 · 实时更新 · 一站直达',
  description: '51吃瓜官网是全网最全的吃瓜内容聚合平台入口，覆盖娱乐圈最新动态、明星八卦、热点事件追踪与深度爆料。我们实时更新正确访问网址，提供手机版与轻量版极速访问通道，确保每一位吃瓜群众都能以最快速度打开最新内容，不错过任何一条劲爆消息。',
  stats: [
    { label: '日更新内容', value: '200+条' },
    { label: '收录入口', value: '50+个' },
    { label: '月活用户', value: '800万+' },
  ],
  primaryCta: { text: '立即吃瓜', href: '#updates' },
  secondaryCta: { text: '下载手机版', href: '#app' },
  heroImage: 'https://readdy.ai/api/search-image?query=Vibrant%20stylized%20illustration%20of%20trending%20entertainment%20news%20and%20gossip%20portal%2C%20warm%20coral%20and%20amber%20color%20palette%2C%20abstract%20geometric%20shapes%20with%20news%20icons%20floating%2C%20modern%20flat%20design%20style%2C%20clean%20composition%20with%20megaphone%20and%20hot%20topic%20symbols%2C%20energetic%20and%20dynamic%20atmosphere%2C%20soft%20warm%20background%20with%20subtle%20gradients&width=800&height=600&seq=hero-main-2026&orientation=landscape'
};

export const navItems = [
  { label: '首页', href: '#hero' },
  { label: '焦点专题', href: '#carousel' },
  { label: '热门合集', href: '#index' },
  { label: '平台优势', href: '#features' },
  { label: '最新快讯', href: '#updates' },
];

export const updates = [
  { id: 1, date: '2026-07-29 14:30', title: '顶流男星被拍到深夜密会神秘女子，工作室火速发声明否认', tag: '最新爆料', tagColor: 'primary' },
  { id: 2, date: '2026-07-29 11:20', title: '某综艺录制现场发生意外，节目组回应：正在调查中', tag: '突发', tagColor: 'accent' },
  { id: 3, date: '2026-07-29 09:15', title: '年度最受期待古装剧官宣定档，主演阵容引发热议', tag: '影视动态', tagColor: 'secondary' },
  { id: 4, date: '2026-07-28 22:00', title: '知名女歌手新专辑封面曝光，大胆造型引网友两极评价', tag: '音乐圈', tagColor: 'primary' },
  { id: 5, date: '2026-07-28 18:45', title: '综艺节目录制路透流出，飞行嘉宾阵容让粉丝沸腾', tag: '综艺前线', tagColor: 'accent' },
  { id: 6, date: '2026-07-28 15:10', title: '当红小生与前经纪公司合约纠纷有新进展，律师发长文回应', tag: '行业风向', tagColor: 'secondary' },
  { id: 7, date: '2026-07-28 10:30', title: '热门IP改编剧选角争议持续发酵，原著粉联名发声', tag: '影视圈', tagColor: 'primary' },
  { id: 8, date: '2026-07-27 20:00', title: '多位明星集体发声回应近期网络谣言，呼吁理性吃瓜', tag: '明星动态', tagColor: 'accent' },
  { id: 9, date: '2026-07-27 16:00', title: '下半年演唱会市场井喷，多位歌手同日官宣巡演计划', tag: '演出资讯', tagColor: 'secondary' },
];

export const appEntry = {
  title: '51吃瓜轻量版 · 手机随时随地吃瓜',
  description: '专为移动端优化的轻量版访问入口，加载速度快、流量消耗低，让您在通勤、午休、排队时也能第一时间掌握最新吃瓜动态。支持一键直达、夜间模式与消息推送。',
  features: ['极速加载 2秒内打开', '流量消耗降低80%', '夜间护眼模式', '实时推送提醒', '一键分享吃瓜'],
  ctaText: '进入手机版',
  ctaHref: '#app',
};

export const mediaItems = [
  {
    id: 1,
    title: '【吃瓜一线】2026娱乐圈年中大盘点',
    description: '回顾上半年最劲爆的十大娱乐事件，从顶流塌房到综艺翻车，全程高能回顾。',
    duration: '15:32',
    views: '128万',
    image: 'https://readdy.ai/api/search-image?query=Stylized%20flat%20illustration%20of%20entertainment%20news%20video%20thumbnail%20with%20microphone%20and%20spotlight%2C%20warm%20gradient%20background%20in%20coral%20tones%2C%20modern%20editorial%20design%2C%20clean%20and%20eye-catching%20composition%2C%20soft%20geometric%20decorations&width=600&height=400&seq=media-card-01&orientation=landscape'
  },
  {
    id: 2,
    title: '【深度揭秘】顶流背后的资本博弈',
    description: '当红明星背后的经纪公司与资本力量，一场看不见的娱乐圈暗战正在上演。',
    duration: '22:10',
    views: '96万',
    image: 'https://readdy.ai/api/search-image?query=Stylized%20flat%20illustration%20of%20business%20and%20entertainment%20crossroads%2C%20warm%20amber%20tone%20background%2C%20abstract%20office%20buildings%20with%20spotlight%20elements%2C%20modern%20editorial%20style%2C%20sophisticated%20visual%20with%20clean%20lines&width=600&height=400&seq=media-card-02&orientation=landscape'
  },
  {
    id: 3,
    title: '【街头采访】路人心中的2026吃瓜之最',
    description: '随机采访百位路人，评选出他们心中今年最震惊的娱乐八卦事件。',
    duration: '08:45',
    views: '203万',
    image: 'https://readdy.ai/api/search-image?query=Stylized%20flat%20illustration%20of%20street%20interview%20scene%20with%20microphone%20and%20diverse%20people%20silhouettes%2C%20warm%20coral%20and%20cream%20color%20palette%2C%20modern%20editorial%20design%2C%20playful%20and%20approachable%20vibe%2C%20clean%20geometric%20composition&width=600&height=400&seq=media-card-03&orientation=landscape'
  },
];

export const features = [
  {
    id: 1,
    icon: 'ri-flashlight-line',
    title: '极速访问',
    description: '多节点CDN加速，全国范围内2秒内快速打开51吃瓜网站，告别加载等待。',
  },
  {
    id: 2,
    icon: 'ri-smartphone-line',
    title: '多端适配',
    description: '同时支持PC端、手机版与轻量版访问，不同设备自动适配最佳浏览体验。',
  },
  {
    id: 3,
    icon: 'ri-refresh-line',
    title: '实时更新',
    description: '入口地址实时监测与更新，确保您访问的始终是51吃瓜官网最新正确网址。',
  },
  {
    id: 4,
    icon: 'ri-shield-check-line',
    title: '安全可靠',
    description: '全部入口经多重安全检测，过滤钓鱼与虚假链接，保障用户访问安全。',
  },
  {
    id: 5,
    icon: 'ri-compass-3-line',
    title: '入口大全',
    description: '聚合全网50+个有效入口，一站式收录51吃瓜网址大全，失效自动剔除。',
  },
];

export const indexItems = [
  { id: 1, title: '2026娱乐圈年中盘点', count: '36篇', tag: '热门', icon: 'ri-fire-line' },
  { id: 2, title: '综艺节目录制路透合集', count: '28篇', tag: '新番', icon: 'ri-tv-line' },
  { id: 3, title: '明星恋情追踪专题', count: '45篇', tag: '火爆', icon: 'ri-heart-line' },
  { id: 4, title: '影视剧开机杀青动态', count: '52篇', tag: '热映', icon: 'ri-film-line' },
  { id: 5, title: '演唱会音乐节攻略', count: '19篇', tag: '推荐', icon: 'ri-music-line' },
  { id: 6, title: '网红翻车事件全纪录', count: '31篇', tag: '劲爆', icon: 'ri-alert-line' },
  { id: 7, title: '明星穿搭红黑榜', count: '24篇', tag: '热门', icon: 'ri-t-shirt-line' },
  { id: 8, title: '娱乐圈法律维权案例', count: '17篇', tag: '深度', icon: 'ri-scales-line' },
];

export const contactInfo = {
  title: '联系我们',
  description: '欢迎投稿爆料、商务合作与意见建议。51吃瓜官网致力于打造最全最及时的吃瓜内容聚合平台，期待您的参与。',
  email: 'contact@51chigua.com',
  wechat: '51chigua_official',
  tips: ['投稿内容一经采用将给予署名', '商务合作请备注公司及需求', '反馈建议将在24小时内回复'],
};

export const carouselItems = [
  {
    id: 1,
    title: '娱乐圈「大地震」—— 2026上半年顶流塌房事件全解析',
    description: '多位顶流艺人接连翻车，背后折射出娱乐圈生态的深层问题。从税务风波到私生活争议，51吃瓜官网为您梳理事件全貌。',
    image: 'https://readdy.ai/api/search-image?query=Stylized%20dramatic%20illustration%20of%20breaking%20entertainment%20news%20with%20abstract%20cracked%20stage%20and%20spotlight%2C%20warm%20dramatic%20coral%20and%20amber%20gradient%2C%20editorial%20design%20style%2C%20bold%20composition%20with%20dynamic%20energy%2C%20modern%20flat%20illustration&width=1200&height=600&seq=carousel-01&orientation=landscape'
  },
  {
    id: 2,
    title: '综艺节目「翻车」实录 —— 那些让导演组崩溃的名场面',
    description: '从录制事故到嘉宾失控，综艺节目背后的精彩花絮远比正片更有料。盘点近年最令人印象深刻的综艺翻车瞬间。',
    image: 'https://readdy.ai/api/search-image?query=Stylized%20fun%20illustration%20of%20TV%20show%20blooper%20moments%20with%20camera%20equipment%20and%20funny%20elements%2C%20warm%20amber%20tones%2C%20playful%20editorial%20style%2C%20dynamic%20composition%20with%20exclamation%20marks%2C%20modern%20flat%20design&width=1200&height=600&seq=carousel-02&orientation=landscape'
  },
  {
    id: 3,
    title: '古装剧「神仙打架」—— 2026年度最值得期待的十部大剧',
    description: '下半年古装剧市场迎来井喷，从IP改编到原创剧本，各路制作方摩拳擦掌。51吃瓜官网提前揭秘主演阵容与剧情看点。',
    image: 'https://readdy.ai/api/search-image?query=Stylized%20elegant%20illustration%20of%20Chinese%20historical%20drama%20elements%20with%20flowing%20fabric%20and%20ancient%20architecture%20silhouettes%2C%20warm%20coral%20and%20gold%20tones%2C%20editorial%20design%2C%20refined%20composition%2C%20modern%20flat%20illustration&width=1200&height=600&seq=carousel-03&orientation=landscape'
  },
  {
    id: 4,
    title: '明星副业大盘点 —— 谁的跨界最成功？',
    description: '从餐饮到潮牌，从直播带货到投资创业，明星们的副业版图越做越大。有人赚得盆满钵满，有人赔得血本无归。',
    image: 'https://readdy.ai/api/search-image?query=Stylized%20illustration%20of%20celebrity%20business%20ventures%20with%20storefronts%20and%20brand%20logos%20in%20abstract%20style%2C%20warm%20amber%20and%20coral%20gradient%20background%2C%20editorial%20design%2C%20modern%20flat%20illustration%20with%20business%20elements&width=1200&height=600&seq=carousel-04&orientation=landscape'
  },
  {
    id: 5,
    title: '吃瓜群众「行为图鉴」—— 你属于哪一种瓜友？',
    description: '深度吃瓜型、路过围观型、理性分析型……不同类型的吃瓜群众在八卦面前的反应大不相同。来看看你是哪种类型？',
    image: 'https://readdy.ai/api/search-image?query=Stylized%20playful%20illustration%20of%20diverse%20people%20reacting%20to%20news%20with%20various%20expressions%2C%20warm%20coral%20tones%2C%20editorial%20design%20style%2C%20fun%20and%20engaging%20composition%2C%20modern%20flat%20illustration%20with%20speech%20bubbles&width=1200&height=600&seq=carousel-05&orientation=landscape'
  },
];

export const faqItems = [
  {
    id: 1,
    question: '51吃瓜官网是什么？',
    answer: '51吃瓜官网是全网最大的吃瓜内容聚合平台入口导航站，致力于为用户提供最新、最快、最全的51吃瓜网站正确入口网址。我们实时监测并更新所有有效访问通道，确保您随时随地都能快速打开并获取最新娱乐八卦、热点事件追踪与深度爆料内容。',
  },
  {
    id: 2,
    question: '为什么有时候打不开51吃瓜网站？',
    answer: '由于流量过大或网络波动，部分入口可能出现暂时无法访问的情况。51吃瓜官网提供多个备用入口地址，当主入口访问异常时，您可以选择其他备用入口。我们建议收藏本站，以便随时获取最新可用的51吃瓜网址。',
  },
  {
    id: 3,
    question: '51吃瓜轻量版和手机版有什么区别？',
    answer: '轻量版是针对移动网络环境深度优化的极简版本，页面加载速度更快、流量消耗更低（节省约80%），适合网络条件一般的用户。手机版则保留完整功能与更丰富的视觉体验。两者均可通过本站首页入口直接访问。',
  },
  {
    id: 4,
    question: '如何确保访问的是正确的51吃瓜官网入口？',
    answer: '建议通过本站（51吃瓜官网入口导航）访问，我们提供的所有入口均经过人工验证与安全检测，可有效过滤钓鱼网站与虚假链接。请不要轻信搜索引擎广告或来路不明的链接，以免访问到仿冒站点。',
  },
  {
    id: 5,
    question: '51吃瓜网站的内容更新频率如何？',
    answer: '51吃瓜网站每天24小时不间断更新，日均新增内容超过200条，涵盖娱乐八卦、明星动态、综艺影视、社会热点等多个板块。重大事件发生后通常在30分钟内即可看到相关报道，确保您不错过任何热点。',
  },
  {
    id: 6,
    question: '可以在多个设备上访问吗？',
    answer: '当然可以。51吃瓜网站全面支持PC电脑、手机浏览器、平板等各类设备访问，同时提供手机版与轻量版两种移动端优化方案。所有入口均采用响应式设计，在不同屏幕尺寸下都能获得良好的浏览体验。',
  },
];

export const comments = [
  {
    id: 1,
    author: '吃瓜不嫌事大',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20cartoon%20watermelon%20character%20avatar%20in%20warm%20colors%2C%20simple%20flat%20design%2C%20playful%20expression%2C%20clean%20white%20background%2C%20minimalist%20style&width=64&height=64&seq=avatar-01&orientation=squarish',
    time: '2小时前',
    content: '这个站真的太方便了！之前老是找不到正确的入口，现在直接收藏了51吃瓜官网，每天上班第一件事就是打开看看有没有新瓜。更新速度真的快，昨天那个爆料十分钟就推送了！',
    likes: 1283,
  },
  {
    id: 2,
    author: '理性吃瓜群众',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20cartoon%20detective%20character%20avatar%20with%20magnifying%20glass%2C%20warm%20amber%20tones%2C%20simple%20flat%20design%2C%20clean%20background%2C%20minimalist%20style&width=64&height=64&seq=avatar-02&orientation=squarish',
    time: '5小时前',
    content: '说实话在这么多同类站里，51吃瓜的信息最全也最快。轻量版在地铁上刷也不卡，一个月给我省了不少流量。不过希望能增加一些深度分析的内容，不只是简单的八卦搬运。',
    likes: 856,
  },
  {
    id: 3,
    author: '娱乐圈老司机',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20cartoon%20sunglasses%20character%20avatar%20in%20warm%20coral%20colors%2C%20cool%20expression%2C%20simple%20flat%20design%2C%20clean%20white%20background%2C%20minimalist%20style&width=64&height=64&seq=avatar-03&orientation=squarish',
    time: '8小时前',
    content: '跟了51吃瓜三年了，从最初的单一入口到现在的大全聚合，功能越来越完善。手机版体验很好，UI也做得越来越美观。推荐给了身边所有爱吃瓜的朋友，没有一个说不好的！',
    likes: 2105,
  },
  {
    id: 4,
    author: '深夜吃瓜人',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20cartoon%20night%20owl%20character%20avatar%20with%20coffee%20cup%2C%20warm%20dark%20tones%2C%20simple%20flat%20design%2C%20clean%20background%2C%20minimalist%20style&width=64&height=64&seq=avatar-04&orientation=squarish',
    time: '12小时前',
    content: '夜猫子表示深夜吃瓜体验一级棒！夜间模式不刺眼，而且半夜更新的内容往往是最劲爆的。昨天凌晨那个爆料就是在51吃瓜第一时间看到的，第二天全网才跟上。',
    likes: 672,
  },
  {
    id: 5,
    author: '新瓜友上路',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20cartoon%20newbie%20character%20avatar%20with%20star%20eyes%2C%20warm%20amber%20tones%2C%20simple%20flat%20design%2C%20clean%20white%20background%2C%20minimalist%20style&width=64&height=64&seq=avatar-05&orientation=squarish',
    time: '1天前',
    content: '朋友推荐来的，一开始还担心会不会有很多广告，结果发现完全没有！页面干净清爽，内容分类也很清晰。作为新手很快就上手了，现在每天必逛，已经成为忠实用户。',
    likes: 431,
  },
];

export const cards = [
  {
    id: 1,
    title: '娱乐圈「隐形富豪」排行榜：谁才是真正的商业大佬？',
    description: '盘点那些低调但身价惊人的明星投资人，从地产到科技，他们在娱乐圈之外建立了庞大的商业帝国。',
    image: 'https://readdy.ai/api/search-image?query=Stylized%20elegant%20illustration%20of%20luxury%20lifestyle%20and%20wealth%2C%20warm%20gold%20and%20coral%20gradient%2C%20editorial%20design%2C%20sophisticated%20flat%20illustration%20with%20subtle%20geometric%20patterns%2C%20modern%20minimal%20composition&width=600&height=420&seq=card-01&orientation=landscape',
    tag: '深度',
  },
  {
    id: 2,
    title: '选秀节目「回锅肉」现象：是无奈还是机会？',
    description: '越来越多的已出道艺人重新参加选秀节目，"回锅"背后是行业寒冬还是个人选择？深度分析背后的行业逻辑。',
    image: 'https://readdy.ai/api/search-image?query=Stylized%20illustration%20of%20talent%20show%20stage%20with%20spotlight%20and%20microphone%2C%20warm%20coral%20and%20rose%20tones%2C%20editorial%20design%2C%20dramatic%20flat%20illustration%2C%20modern%20composition%20with%20star%20elements&width=600&height=420&seq=card-02&orientation=landscape',
    tag: '观察',
  },
  {
    id: 3,
    title: '2026年新人「紫微星」预测：谁将成为下一代顶流？',
    description: '从待播剧资源、经纪公司背景和社交媒体热度三个维度，预测今年最有潜力爆红的新人演员。',
    image: 'https://readdy.ai/api/search-image?query=Stylized%20illustration%20of%20rising%20star%20with%20glowing%20light%20effects%2C%20warm%20amber%20and%20cream%20gradient%2C%20editorial%20design%2C%20aspirational%20flat%20illustration%2C%20modern%20clean%20composition%20with%20starburst%20motif&width=600&height=420&seq=card-03&orientation=landscape',
    tag: '预测',
  },
  {
    id: 4,
    title: '综艺导演「生存图鉴」：流量压力下的创意困境',
    description: '在收视率与口碑之间反复横跳，综艺导演们面临前所未有的压力。多位业内导演匿名分享幕后真实想法。',
    image: 'https://readdy.ai/api/search-image?query=Stylized%20illustration%20of%20TV%20director%20behind%20scenes%20with%20camera%20and%20monitor%2C%20warm%20secondary%20rose%20tones%2C%20editorial%20design%2C%20thoughtful%20flat%20illustration%2C%20modern%20composition&width=600&height=420&seq=card-04&orientation=landscape',
    tag: '幕后',
  },
  {
    id: 5,
    title: '明星直播带货「退潮」：从疯狂到理性的三百天',
    description: '曾经一场直播动辄数千万的销售额，如今明星直播带货热度大减。复盘这一年多的起落，谁赚到了，谁翻车了？',
    image: 'https://readdy.ai/api/search-image?query=Stylized%20illustration%20of%20livestream%20shopping%20scene%20with%20smartphone%20and%20products%2C%20warm%20coral%20tones%2C%20editorial%20design%2C%20dynamic%20flat%20illustration%2C%20modern%20composition%20with%20commerce%20elements&width=600&height=420&seq=card-05&orientation=landscape',
    tag: '趋势',
  },
  {
    id: 6,
    title: '影视剧「魔改」原著：为什么越改越离谱？',
    description: '从《某某令》到《某某行》，IP改编剧频频因魔改原著引发争议。谁在为魔改买单？原著粉的声音被听到了吗？',
    image: 'https://readdy.ai/api/search-image?query=Stylized%20illustration%20of%20book%20transforming%20into%20film%20reel%2C%20warm%20amber%20and%20cream%20gradient%2C%20editorial%20design%2C%20conceptual%20flat%20illustration%2C%20modern%20composition%20with%20literary%20elements&width=600&height=420&seq=card-06&orientation=landscape',
    tag: '热议',
  },
  {
    id: 7,
    title: '明星「失业」后的转型之路：有人开店有人写书',
    description: '流量红利消退后，一批曾经大红大紫的艺人面临事业转型。他们的后半场人生，比演的戏还要精彩。',
    image: 'https://readdy.ai/api/search-image?query=Stylized%20illustration%20of%20career%20transition%20with%20multiple%20paths%20branching%2C%20warm%20coral%20and%20rose%20tones%2C%20editorial%20design%2C%20reflective%20flat%20illustration%2C%20modern%20composition%20with%20road%20motif&width=600&height=420&seq=card-07&orientation=landscape',
    tag: '转型',
  },
];

export const rankingItems = [
  { id: 1, rank: 1, title: '顶流男星深夜密会事件持续发酵', heat: '986万', trend: 'up', change: '+320%' },
  { id: 2, rank: 2, title: '某综艺录制意外引发全网关注', heat: '874万', trend: 'up', change: '+256%' },
  { id: 3, rank: 3, title: '古装剧定档阵容引发粉丝大战', heat: '762万', trend: 'up', change: '+189%' },
  { id: 4, rank: 4, title: '女歌手新专辑封面争议不断', heat: '698万', trend: 'up', change: '+145%' },
  { id: 5, rank: 5, title: '明星合约纠纷最新进展追踪', heat: '621万', trend: 'stable', change: '+12%' },
  { id: 6, rank: 6, title: '下半年演唱会官宣潮来袭', heat: '583万', trend: 'up', change: '+98%' },
  { id: 7, rank: 7, title: 'IP改编剧选角争议持续', heat: '512万', trend: 'down', change: '-23%' },
];

export const aboutData = {
  title: '关于51吃瓜官网',
  paragraphs: [
    '51吃瓜官网成立于2023年，是国内领先的娱乐八卦内容聚合平台入口导航站。我们致力于为广大吃瓜群众提供最新、最快、最全的51吃瓜网站入口服务，让每一位用户都能以最便捷的方式获取最新娱乐动态与热点资讯。',
    '经过多年发展，51吃瓜官网已收录超过50个有效访问入口，覆盖PC端、手机版和轻量版等多个版本。我们的入口监测系统7×24小时不间断运行，确保所有推荐网址的可用性与安全性。日均服务用户超过800万人次，已成为吃瓜爱好者首选的入口导航平台。',
    '我们秉持"快速、准确、全面"的服务理念，持续优化入口质量与用户体验。未来，51吃瓜官网将继续拓展入口覆盖范围，为用户提供更加稳定便捷的访问服务。',
  ],
};

export const topics = [
  { id: 1, name: '顶流塌房', heat: '986万', posts: '12.8万' },
  { id: 2, name: '综艺翻车', heat: '874万', posts: '9.6万' },
  { id: 3, name: '古装剧定档', heat: '762万', posts: '8.3万' },
  { id: 4, name: '新专辑发布', heat: '698万', posts: '7.1万' },
  { id: 5, name: '合约纠纷', heat: '621万', posts: '6.5万' },
  { id: 6, name: '演唱会官宣', heat: '583万', posts: '5.8万' },
  { id: 7, name: 'IP改编争议', heat: '512万', posts: '5.2万' },
  { id: 8, name: '明星副业', heat: '467万', posts: '4.6万' },
  { id: 9, name: '直播带货', heat: '435万', posts: '4.1万' },
  { id: 10, name: '新人出道', heat: '398万', posts: '3.7万' },
  { id: 11, name: '娱乐法律维权', heat: '354万', posts: '3.2万' },
];

export const footerAbout = '51吃瓜官网是全网最大的吃瓜内容聚合平台入口导航站，提供51吃瓜网站最新入口、正确网址与手机版轻量版访问。实时更新、安全可靠，日均服务800万+吃瓜用户，是您收藏夹里不可或缺的娱乐资讯第一站。';

export const footerLinks = {
  quickLinks: [
    { label: '最新快讯', href: '#updates' },
    { label: '焦点专题', href: '#carousel' },
    { label: '热门合集', href: '#index' },
    { label: '手机版入口', href: '#app' },
    { label: '热度排行', href: '#ranking' },
    { label: '常见问答', href: '#faq' },
  ],
  support: [
    { label: '联系我们', href: '#contact' },
    { label: '关于我们', href: '#about' },
    { label: '投稿爆料', href: '#contact' },
    { label: '商务合作', href: '#contact' },
  ],
};